var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "document") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Joyn-2-Task-Form-View-Copy-10",
    transform: "translate(-208.000000, -3054.000000)",
    fill: "#424F62",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document",
    transform: "translate(208.000000, 3054.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6231156,0 L2.97738693,0 C2.7701005,0 2.60050251,0.171102662 2.60050251,0.380228137 L2.50628141,10.7034221 L0.376884422,10.7034221 C0.16959799,10.7034221 0,10.8745247 0,11.0836502 L0,12.4714829 C0,13.8212928 1.0741206,14.9429658 2.4120603,15 L12.361809,15 C12.3994975,15 12.4560302,15 12.4937186,15 C13.8693467,15 15,13.8593156 15,12.4714829 L15,0.380228137 C15,0.171102662 14.830402,0 14.6231156,0 Z M2.50628141,14.2585551 C1.52638191,14.2585551 0.753768844,13.460076 0.753768844,12.4904943 L0.753768844,11.4828897 L9.98743719,11.4828897 L9.98743719,12.4904943 C9.98743719,13.1558935 10.2512563,13.78327 10.7035176,14.2585551 L2.50628141,14.2585551 Z M12.4937186,14.2585551 C11.5138191,14.2585551 10.741206,13.460076 10.741206,12.4904943 L10.741206,11.1026616 C10.741206,10.8935361 10.571608,10.7224335 10.3643216,10.7224335 L3.27889447,10.7224335 L3.35427136,0.760456274 L14.2462312,0.760456274 L14.2462312,12.4904943 C14.2462312,13.460076 13.4736181,14.2585551 12.4937186,14.2585551 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 5,
    y: 3,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 5,
    y: 5.5,
    width: 7,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 5,
    y: 8,
    width: 7,
    height: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.b3049a682b653e7d263c67e79e0580e8.svg";
export { ForwardRef as ReactComponent };